











import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    LoginForm: () => import('@/components/LoginForm.vue')
  }
})
export default class Login extends Vue {}
